import { render } from "./UserVisitLogIndex.vue?vue&type=template&id=4d39562a&scoped=true"
import script from "./UserVisitLogIndex.vue?vue&type=script&lang=js"
export * from "./UserVisitLogIndex.vue?vue&type=script&lang=js"

import "./UserVisitLogIndex.vue?vue&type=style&index=0&id=4d39562a&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d39562a"]])

export default __exports__